import * as rive from "@rive-app/canvas";

export default function riveAnimations() {
  const els = [...document.querySelectorAll(".rive-canvas")];
  const lang = document.documentElement.getAttribute('lang');
  window.animations = els.map((el, i) => {
    const src = `/wp-content/themes/theme/dist/rive/stacked-card-${i+1}${lang === 'pt-BR' ? '-pt-br': ''}.riv`;
    // console.log(src);
    return new rive.Rive({
      src,
      canvas: el,
      onStop: () => {
        if (!window.animations[i+1]) return;
        window.animations[i+1].play();
      }
    });
  });

  document.addEventListener(`aos:in:stackedinview`, () => {
    if (window.animations && window.animations.length > 0) {
      window.animations[0].play();
    }
  });
}
